'use strict';

/**
 * List view modes.
 * @enum {String}
 */
export const ViewMode = {
  LOADING: 'loading',
  LOADING_MORE: 'loading_more',
  SUCCESS: 'success',
  EOTHER: 'error',
  ENONET: 'no_network',
};

export function isErrorViewMode(mode) {
  return mode === ViewMode.EOTHER || mode.ENONET;
}

/**
 * List sort methods.
 * @enum {String}
 */
export const SortMethod = {
  ASCENDING: 'ascending',
  DESCENDING: 'descending',
  NONE: 'none',
};

/**
 * HTTP verbs.
 * @enum {String}
 */
export const HttpMethod = {
  GET: 'GET',
  PATCH: 'PATCH',
  POST: 'POST',
  PUT: 'PUT',
  DELETE: 'DELETE',
  HEAD: 'HEAD',
  OPTIONS: 'OPTIONS',
};

/**
 * Devire the ViewMode from the error status.
 * @param {Number} status
 * @return {ViewMode}
 */
export function viewModeFromErrorStatus(status) {
  return status === 0 ? ViewMode.ENONET : ViewMode.EOTHER;
}

/**
 * @param {SortMethod} method
 * @return {?String}
 */
export function serverValForSortMethod(method) {
  switch (method) {
    case SortMethod.ASCENDING:
      return 'asc';
    case SortMethod.DESCENDING:
      return 'desc';
    case SortMethod.NONE:
    default:
      return null;
  }
}

/**
 * @typedef {String} SyncStatus
 */

export const SyncStatus = {
  /** @type {SyncStatus} default case: item is in sync with the server */
  NONE: void 0,
  /** @type {SyncStatus} item has been updated on the client and is pending sync attempt with the server */
  PENDING: 'PENDING',
  /** @type {SyncStatus} sync attempt with the server is in progress */
  IN_PROGRESS: 'IN_PROGRESS',
  /** @type {SyncStatus} sync attempt with the server is in progress, but we've recieved another pending update */
  IN_PROGRESS_W_PENDING: 'IN_PROGRESS_W_PENDING',
  /** @type {SyncStatus} sync attempt with the server was successful */
  SUCCESS: 'SUCCESS',
  // TODO: add others

  UNRECOVERABLE: 'UNRECOVERABLE',
};

export function syncInProgress(status) {
  return status === SyncStatus.IN_PROGRESS || status === SyncStatus.IN_PROGRESS_W_PENDING;
}

export function getSyncStatus(current) {
  if (current && (current.status === SyncStatus.IN_PROGRESS || current.status === SyncStatus.IN_PROGRESS_W_PENDING)) {
    return SyncStatus.IN_PROGRESS_W_PENDING;
  } else {
    return SyncStatus.PENDING;
  }
}



// WEBPACK FOOTER //
// ./src/js/_libs/redux-observable-list/src/enums.js